module.exports = __webpack_public_path__ + "img/modal_cedula_c2026.c729c7e7.jpg";